/* eslint-disable */ function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import React, { useEffect, useState } from "react";
export default function DownloadsTable(props) {
    // Fetch a token from edge function endpoint
    var _useState = _sliced_to_array(useState(null), 2), token = _useState[0], setToken = _useState[1];
    useEffect(function() {
        fetch("/edge-functions/create-token").then(function(response) {
            return response.json();
        }).then(function(data) {
            setToken(data.hash);
        }).catch(function(error) {
            console.error("There was a problem with the fetch operation:", error.message);
        });
    }, []);
    var _props_description, _section_description, _props_downloadsFooter;
    return /*#__PURE__*/ React.createElement("div", {
        className: "page-container first:mt-0 mt-8 md:mt-0"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "prose max-w-full"
    }, /*#__PURE__*/ React.createElement("h2", null, props === null || props === void 0 ? void 0 : props.header), /*#__PURE__*/ React.createElement("p", null, /*#__PURE__*/ React.createElement("div", {
        dangerouslySetInnerHTML: {
            __html: (_props_description = props === null || props === void 0 ? void 0 : props.description) !== null && _props_description !== void 0 ? _props_description : ""
        }
    })), (props === null || props === void 0 ? void 0 : props.downloadSections) && (props === null || props === void 0 ? void 0 : props.downloadSections.map(function(section, index) {
        /*#__PURE__*/ return React.createElement("table", {
            className: "table knime-table",
            key: index
        }, /*#__PURE__*/ React.createElement("tbody", null, /*#__PURE__*/ React.createElement("tr", {
            className: "theme-header"
        }, /*#__PURE__*/ React.createElement("td", {
            colSpan: 3
        }, /*#__PURE__*/ React.createElement("h3", {
            className: "font-bold"
        }, section === null || section === void 0 ? void 0 : section.sectionHeader), /*#__PURE__*/ React.createElement("p", null, /*#__PURE__*/ React.createElement("em", null, /*#__PURE__*/ React.createElement("div", {
            dangerouslySetInnerHTML: {
                __html: (_section_description = section === null || section === void 0 ? void 0 : section.description) !== null && _section_description !== void 0 ? _section_description : ""
            }
        }))))), (section === null || section === void 0 ? void 0 : section.items) && section.items.map(function(item, itemIndex) {
            /*#__PURE__*/ return React.createElement("tr", {
                key: itemIndex
            }, /*#__PURE__*/ React.createElement("td", null, item === null || item === void 0 ? void 0 : item.title), /*#__PURE__*/ React.createElement("td", {
                className: "w-1/5"
            }, /*#__PURE__*/ React.createElement("a", {
                href: "".concat(props.baseDownloadUrl, "?media_id=").concat(item === null || item === void 0 ? void 0 : item.mediaId).concat(token ? "&token=".concat(token) : "")
            }, "Download"), /*#__PURE__*/ React.createElement("span", {
                className: "ml-3"
            }, "(", item === null || item === void 0 ? void 0 : item.size, ")")));
        })));
    })), /*#__PURE__*/ React.createElement("footer", {
        className: "mt-12"
    }, /*#__PURE__*/ React.createElement("p", {
        className: "rtejustify"
    }, /*#__PURE__*/ React.createElement("div", {
        dangerouslySetInnerHTML: {
            __html: (_props_downloadsFooter = props === null || props === void 0 ? void 0 : props.downloadsFooter) !== null && _props_downloadsFooter !== void 0 ? _props_downloadsFooter : ""
        }
    })))));
}
